import { resources } from "@constants/hardcoded-strings";
import { MESSAGE_TEMPLATES_DETAILS_URL } from "@constants/routes";
import { MESSAGE_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";
import { TableCellWithDropdown } from "@containers/common/table-cell-with-dropdown/table-cell-with-dropdown";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { navigateToUtil } from "@utils/navigation-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type MessageTemplateCellProps = {
    value: string;
    messageTemplate: FormattedMessageTemplate;
}

export const MessageTemplatesCell = (props: MessageTemplateCellProps) => {
    const { value, messageTemplate } = props;
    const routerLocation = useLocation();
    const navigate = useNavigate();

    const onClickRedirectToDetails = () => {
        const url = injectCustomIdParameter(MESSAGE_TEMPLATES_DETAILS_URL, messageTemplate.id, MESSAGE_TEMPLATE_ID_PATTERN);
        navigateToUtil(url, navigate, routerLocation.pathname);
    }

    const dropdownItems = useMemo(() => {
        const prefix = 'message-template-table-dropdown-item';
        const items = [];

        if (messageTemplate.permissions.canView) {
            items.push({
                idSuffix: `${prefix}-open`,
                title: resources.tables.messageTemplates.dropdownItems.openDetails.label,
                text: resources.tables.messageTemplates.dropdownItems.openDetails.label,
                onClick: onClickRedirectToDetails
            });
        }

        return items;

    }, []);

    return (<TableCellWithDropdown
        value={value}
        dropdownText={""}
        items={dropdownItems}
        uniqueId={messageTemplate.id}
    />);
}